// @ts-ignore
import * as L from 'leaflet/dist/leaflet-src.esm.js';
import * as M from 'leaflet';
import { GestureHandling } from 'leaflet-gesture-handling';
/**
 * The class used to initialize leaflet plugins
 */
export class PluginManager {
    /**
       * Method used in order to initialize leaflet gesture plugin
       * @param zoomOnlyWithControlKey Flag that indicates if we are going to use plugin in order to
       * force user to press control key while he moves mouse wheel for zooming in map.
       */
    initializeLeafletGestureHandlePlugin(zoomOnlyWithControlKey) {
        if (zoomOnlyWithControlKey) {
            // Add gesture handling plugin to leaflet
            // This is the addInitHook necessary for the plugin to work on dinapsis-map.map instance
            L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
            // This addInitHook method is called over M instance of leaflet only in order to
            // force compiler to add leaflet import before leaflet-gesture-handler plugin is imported.
            // I don't know why, if we remove this line, import of leaflet-gesture-handler fails
            // because it doesn't find any leaflet instance to apply the plugin.
            M.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
        }
    }
}
//# sourceMappingURL=pluginManager.js.map